// GDPR / Loi 2008-12 cookie consent banner.
// Uses shadcn/ui components. Stores preference in localStorage.
// PostHog only activates after user accepts.

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@cieda/ui";
import { getStoredConsent, setConsent } from "@/lib/posthog";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner only if no consent decision has been made
    const consent = getStoredConsent();
    if (consent === null) {
      // Small delay to avoid layout shift on initial render
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setConsent("accepted");
    setVisible(false);
  };

  const handleReject = () => {
    setConsent("rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Consentement aux cookies"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
    >
      <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-background/95 backdrop-blur-md shadow-2xl p-5 md:p-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-start md:gap-6">
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-foreground mb-1.5">
              Nous respectons votre vie privée
            </h3>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Nous utilisons des cookies pour analyser le trafic et améliorer votre expérience.
              Aucune donnée personnelle n'est partagée avec des tiers.
              Consultez notre{" "}
              <Link
                to="/politique-confidentialite"
                className="text-secondary underline underline-offset-2 hover:text-secondary/80"
              >
                politique de confidentialité
              </Link>{" "}
              pour en savoir plus.
            </p>
          </div>
          <div className="flex gap-3 shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={handleReject}
              className="text-xs"
            >
              Refuser
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="bg-secondary text-secondary-foreground hover:bg-secondary/90 text-xs"
            >
              Accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
